import ContentAsset from "@components/BasicComponents/ContentAsset/ContentAsset"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
// import ContentAssetSwitcher from "@components/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AdvancedSideAssetModuleType
}

const AuditsSection = (props: Props) => {
	return (
		<section>
			<Separator backgroundColor={"#F8FAFE"} size={128}>
				<ContainerWrapper>
					<Typography
						content={props.data.sectionTitle}
						fontWeight={300}
						variant={Variant.SectionTitle}
					/>
					<Separator />
					{props.data.mainContent && (
						<ContentAsset data={props.data.mainContent?.[0]} />
					)}
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default AuditsSection
